import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

import { ContentCategory } from '@backrs_ui/common-ui';

import { getBackrsToken } from '@backrs_ui/grow-ui/src/utils/tokenHelpers';

// import { getBackrsToken } from '../../helpers/tokenHelpers';
import { logout } from '../session/logoutThunk';
import { RootState } from '../store';

const ENVIRONMENT_URL = process.env.REACT_APP_API_BASEURL;

type ContentCategoryState = Readonly<{
  contentCategories?: ContentCategory[];
  loading: boolean;
  error?: string;
}>;

const initialState: ContentCategoryState = {
  contentCategories: [],
  loading: false,
};

export const fetchContentCategories = createAsyncThunk(
  'contentCategory/fetchContentCategories',
  async (_, { rejectWithValue }) => {
    const accessToken = getBackrsToken();

    try {
      const response = await fetch(`${ENVIRONMENT_URL}/content-category`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });

      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

      const data = await response.json();

      return data as ContentCategory[];
    } catch (error) {
      return rejectWithValue(`Failed to fetch content categories with error: ${error}`);
    }
  },
);

export const contentCategorySlice = createSlice({
  name: 'contentCategory',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchContentCategories.pending, (state) => {
        state.loading = true;
        state.error = undefined;
      })
      .addCase(
        fetchContentCategories.fulfilled,
        (state, action: PayloadAction<ContentCategory[]>) => {
          state.contentCategories = action.payload;
          state.loading = false;
        },
      )
      .addCase(fetchContentCategories.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })

      // LOGOUT
      .addCase(logout, (state) => {
        state.contentCategories = [];
        state.loading = false;
        state.error = undefined;
      });
  },
});

// Other code such as selectors can use the imported `RootState` type
export const selectContentCategories = (state: RootState) => state.contentCategory;

export const contentCategoryReducer = contentCategorySlice.reducer;
